/* ====================================================================
   QUEEN LENGTH V2 — fast-CTA layout JS
   - Qty stepper (+/- buttons) synced between main and sticky
   - Shade drawer toggle (collapsed by default)
   - Shade picker → updates hidden variant ID + hero image + price
   - Sticky bar visibility via IntersectionObserver
   - Sticky bar CTA delegates to real form submit
   - Cart drawer opens after add-to-cart
   ==================================================================== */

(function () {
  'use strict';

  function formatMoney(cents, symbol) {
    var s = symbol || '$';
    var num = Math.round(cents) / 100;
    var amount = num % 1 === 0 ? num.toString() : num.toFixed(2);
    return s + amount;
  }

  function init(scope) {
    var root = scope || document;
    var sections = root.querySelectorAll('[data-ql-section]');
    sections.forEach(initSection);
  }

  function initSection(section) {
    if (section.dataset.qlInit === '1') return;
    section.dataset.qlInit = '1';

    var currencySymbol = section.dataset.qlCurrency || '$';

    // Keep both information panels readable without JavaScript. Enhance to tabs
    // only after their controls and keyboard behaviour have been connected.
    section.querySelectorAll('[data-ql-info-tabs]').forEach(function (info) {
      var bar = info.querySelector('[role="tablist"]');
      var tabs = Array.prototype.slice.call(info.querySelectorAll('[role="tab"]'));
      var panels = tabs.map(function (tab) {
        return info.querySelector('#' + tab.getAttribute('aria-controls'));
      });
      if (!bar || tabs.length !== 2 || panels.some(function (panel) { return !panel; })) return;
      function selectTab(index, focus) {
        tabs.forEach(function (tab, i) {
          tab.setAttribute('aria-selected', i === index ? 'true' : 'false');
          tab.tabIndex = i === index ? 0 : -1;
          panels[i].hidden = i !== index;
        });
        if (focus) tabs[index].focus();
      }
      tabs.forEach(function (tab, index) {
        tab.addEventListener('click', function () { selectTab(index, false); });
        tab.addEventListener('keydown', function (event) {
          var next;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          else if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = tabs.length - 1;
          else return;
          event.preventDefault();
          selectTab(next, true);
        });
      });
      selectTab(0, false);
      info.classList.add('is-enhanced');
      bar.hidden = false;
    });
    var unitMode = section.dataset.qlUnitMode || 'packs';
    var gramsPerPack = parseInt(section.dataset.qlGrams || '90', 10);

    var state = {
      unitCents: parseInt(section.dataset.qlBasePrice || '0', 10),
      qty: 1,
      shadeName: ''
    };

    // ----- Cache nodes
    var qtyInput = section.querySelector('[data-ql-qty]');
    var variantInput = section.querySelector('[data-ql-variant-id]');
    var totalEls = section.querySelectorAll('[data-ql-total]');
    var unitEls = section.querySelectorAll('[data-ql-unit]');
    var heroImg = section.querySelector('[data-ql-hero]');
    var heroSource = section.querySelector('[data-ql-hero-source]');
    var shadeNameEls = section.querySelectorAll('[data-ql-shade-name]');
    var selectedNameEl = section.querySelector('[data-qlv2-selected-name]');
    var stickybar = section.querySelector('[data-ql-stickybar]');
    var mainCta = section.querySelector('[data-ql-main-cta]');
    var mainCtaLabel = section.querySelector('[data-ql-cta-label]');
    var stickyCta = section.querySelector('[data-ql-sticky-cta]');
    var stickyForcedByShade = false;
    var updateStickybar = null;
    var tierChips = section.querySelectorAll('[data-ql-tier]');
    var bundleMsgEl = section.querySelector('[data-qlv2-bundle-msg]');
    var bundleTiles = section.querySelectorAll('[data-ql-bundle-select]');

    // Stepper elements (main)
    var minusBtn = section.querySelector('[data-ql-qty-minus]');
    var plusBtn = section.querySelector('[data-ql-qty-plus]');
    var qtyDisplay = section.querySelector('[data-ql-qty-display]');

    // Stepper elements (sticky)
    var stickyMinusBtn = section.querySelector('[data-ql-sticky-minus]');
    var stickyPlusBtn = section.querySelector('[data-ql-sticky-plus]');
    var stickyQtyDisplay = section.querySelector('[data-ql-sticky-qty-display]');
    var stickyPrice = section.querySelector('[data-ql-sticky-price]');

    // Shade section


    // 2026-10-10: mirrors the live Shopify automatic discounts (fixed $ off each braid pack).
    // 2026-10-11: the amounts are AUD. In another currency Shopify converts them at checkout
    // (US: $5 AUD = $3.56 off), so convert here with the same live rate or the page undercuts checkout.
    var FX = parseFloat(((window.Shopify || {}).currency || {}).rate) || 1;
    // 2026-10-11 (founder): no gifts for US / Canada. Set in layout/theme.liquid.
    var GIFT_OFF = !!(window.AC_GIFT && window.AC_GIFT.off);
    // Match Shopify's trade-account customer segment. Guests and untagged buyers get retail tiers.
    var tradeEligible = section.dataset.qlTradeEligible === 'true';
    function perPackOff(n) {
      var aud = 0;
      if (tradeEligible && n >= 75) aud = 1310;
      else if (tradeEligible && n >= 40) aud = 1225;
      else if (tradeEligible && n >= 20) aud = 1140;
      else if (n >= 6) aud = 500;
      return Math.round(aud * FX);
    }

    // ----- Render all dynamic elements
    function render() {
      var totalCents = state.unitCents * state.qty;
      // ONE RUNG ONLY, AND IT MOVED 6+ -> 8+ ON 2026-08-08.
      // Founder 2026-08-08: "first remove discount for low ballers, takes the same amount
      // of effort to serve or get same clients." The 6+ rung WAS the $90 magnet: six packs
      // at $17 is $102 gross and 11.77% landed it on exactly $90.00, so we were
      // manufacturing the median, not lifting it. 13 of 54 braid orders parked on $90.00
      // to the cent. Now 1-7 packs pay full price and the only rung lands 8 packs on
      // exactly $120.00 ($136 gross - $16). Seven packs full price is $119, so one dollar
      // buys a whole extra pack plus two gifts.
      // The separate 8+ (26.47%), 12+ (31.37%) and 75+ (35%) rungs stay DEACTIVATED.
      // Rates MUST match the live Shopify automatic discount ("Mix & Save · 8 for $120",
      // 11.77%, min qty 8) so the sticky/ATC price = the cart.
      // 2026-08-08 also fixed here: this line ROUNDED the discount while Shopify FLOORS it,
      // and carried 0.1176 while the nudge below carried 0.1177. At 8 packs that combination
      // printed $120.01 against a checkout that charges $120.00, putting the gift door one
      // cent out of reach on the page. Floor the discount, never round the total.
      var bundleRate = 0;
      // 2026-10-10 PRICE STAIRCASE (founder): $25 a pack, $20 a pack from 6. Shopify charges it with
      // automatic "$ off each item" discounts on the 3 braid products, counted across the whole bag.
      // perPackOff() MUST match those discounts: 6+ $5 · 20+ $11.40 · 40+ $12.25 · 75+ $13.10 off each.
      var effQty = state.qty + (window.QLV2_CART_BRAIDS || 0);
      var unitNet = Math.max(0, state.unitCents - perPackOff(effQty));
      totalCents = unitNet * state.qty;
      section.dataset.acDeliveryQty = state.qty;
      section.dataset.acDeliveryNet = unitNet;
      section.dataset.acDeliveryOriginal = state.unitCents;
      section.dispatchEvent(new CustomEvent('ac:delivery-selection', { bubbles: true }));
      var totalStr = formatMoney(totalCents, currencySymbol);
      var unitStr = formatMoney(unitNet, currencySymbol);

      totalEls.forEach(function (el) { el.textContent = totalStr; });
      // Six-pack headline + pack line, exact in every currency (liquid can only estimate abroad).
      var sixEach = Math.max(0, state.unitCents - perPackOff(6));
      section.querySelectorAll('[data-ac-six-total]').forEach(function (el) { el.textContent = formatMoney(sixEach * 6, currencySymbol); });
      section.querySelectorAll('[data-ac-six-each]').forEach(function (el) { el.textContent = formatMoney(sixEach, currencySymbol); });
      unitEls.forEach(function (el) { el.textContent = unitStr; });
      if (mainCtaLabel) mainCtaLabel.textContent = mainCta.disabled ? 'Sold out' : mainCta.hasAttribute('data-ql-simple-cta') ? 'ADD TO CART' : state.qty === 1 ? 'ADD 1 PACK' : 'ADD ' + state.qty + ' PACKS';

      // Qty displays (support both input and span)
      if (qtyDisplay) {
        if (qtyDisplay.tagName === 'INPUT') qtyDisplay.value = state.qty;
        else qtyDisplay.textContent = state.qty;
      }
      if (stickyQtyDisplay) {
        if (stickyQtyDisplay.tagName === 'INPUT') stickyQtyDisplay.value = state.qty;
        else stickyQtyDisplay.textContent = state.qty;
      }

      // Sticky price = total
      if (stickyPrice) stickyPrice.textContent = totalStr;

      // Qty input
      if (qtyInput) qtyInput.value = state.qty;

      // Tier chips
      tierChips.forEach(function (chip) {
        var tier = parseInt(chip.getAttribute('data-ql-tier'), 10);
        chip.classList.toggle('ql-tier--active', state.qty >= tier);
      });

      // Reflect which Mix & Save tile matches the current qty
      bundleTiles.forEach(function (t) {
        var on = parseInt(t.getAttribute('data-ql-bundle-select'), 10) === state.qty;
        t.classList.toggle('qlv2-mixsave__col--selected', on);
        t.setAttribute('aria-pressed', on ? 'true' : 'false');
      });

      // ----- Live bundle savings message — Mix & Save ladder 4/8/12/75 (2026-06-06 PM)
      // CART-AWARE for candy buyers: when other braiding packs already sit in the bag
      // from a different shade, the nudge shows the COMBINED total + the path to the
      // next rung. So a candy buyer with 3 in bag opening a new shade sees "1 more to
      // unlock 12% off", not the wrong-by-self "Add 3 more". Founder call 2026-06-06.
      if (bundleMsgEl) {
        var q = state.qty;
        var cartBraids = (window.QLV2_CART_BRAIDS || 0);
        var eff = q + cartBraids;
        var msg = '';
        var packs = function (n) { return n === 1 ? 'pack' : 'packs'; };

        // 2026-07-19 PRICE-AWARE REWRITE (founder caught it): the old rungs equated
        // "6 packs" with the $90 free-ship + 2-gifts line, which is only true at $17
        // (26"/22"). On the $13 16" page, 6 packs = ~$69 after discount, so the nudge
        // promised gifts the checkout never gave. Now the $90 threshold is computed
        // from the page's real unit price WITH the Mix & Save tier applied, so every
        // promise is checkout-true on every length. Discount rungs (6/8/12/75) are
        // pack-count-based and stay as-is. When $90 is far (short lengths), the nudge
        // points at the nearest discount rung instead of a distant gift line.
        // 2026-07-27: one rung. 6+ only. Everything deeper is deactivated in Shopify.
        // 2026-07-28 rate corrected 0.115 -> 0.1177 to match the live Shopify discount exactly
        // (verified against automaticDiscountNodes: "Mix & Save · 6 for $90", 11.77%, min qty 6).
        // The 0.115 was drift from the 07-04 spec and made the page quote a price checkout did not charge.
        // 2026-08-08: rung moved 6+ -> 8+ to match the live Shopify discount.
        var tierRate = function () { return 0; };
        // 2026-07-28 ROUNDING FIXED TO MATCH SHOPIFY. Rounding the whole discounted total put every
        // door one cent out of reach: 6 packs computed $89.99 against a $90 door and 8 packs computed
        // $119.99 against a $120 door, so the page would have told her to add a NINTH pack for gifts
        // she already had. Shopify FLOORS the discount amount and subtracts it, verified against real
        // orders: 6 packs (orig $102) charged exactly $90.00, 8 packs (orig $136) charged exactly
        // $120.00. Floor the discount, never round the total.
        // 2026-10-10: braid spend after the $ off each staircase. Approximates the bag as all this
        // length's price, which is exact now every length is $25.
        var discountedCents = function (n) {
          return n * Math.max(0, state.unitCents - perPackOff(n));
        };
        // 2026-08-07: GIFT_CENTS reverted 12000 -> 9000 (founder: "Revert it"). Both doors read $90 again,
        // but KEEP THEM AS TWO VARIABLES. SHIP_CENTS is free Express on TOTAL cart; GIFT_CENTS is the
        // Install Kit on BRAID spend. They have matched before and split before, and collapsing them into
        // one constant is how the $100/$90/$120 drift happened. GIFT_CENTS must match window.AC_GIFT.threshold.
        var SHIP_CENTS = 10000; // 2026-10-12: free Express $90 -> $100 (founder)
        var GIFT1_CENTS = 12000;
        var GIFT2_CENTS = 14000;
        var GIFT_CENTS = GIFT1_CENTS;
        var shipAt = eff;
        while (shipAt < 40 && discountedCents(shipAt) < SHIP_CENTS) shipAt++;
        var shipIn = shipAt - eff;
        var shipNow = shipIn === 0;
        var giftsAt = eff;
        while (giftsAt < 40 && discountedCents(giftsAt) < GIFT_CENTS) giftsAt++;
        var giftsIn = giftsAt - eff;
        var giftsNow = giftsIn === 0;
        var gift2At = eff;
        while (gift2At < 40 && discountedCents(gift2At) < GIFT2_CENTS) gift2At++;
        var gift2In = gift2At - eff;
        var gift2Now = gift2In === 0;
        // 2026-08-08: the only rung is 8+ now.
        var nextRung = 0;
        var rungIn = nextRung ? nextRung - eff : 0;
        var bag = cartBraids > 0 ? cartBraids + ' in your bag · ' : '';
        var subtotalCents = state.unitCents * q;
        var savedStr = formatMoney(Math.floor(subtotalCents * bundleRate), currencySymbol);
        var saved = (cartBraids === 0 && bundleRate > 0) ? ' · save ' + savedStr : '';

        // One rung, so there is no "add more for a deeper price" any more. Once she is
        // in, the message confirms what she has rather than dangling the next discount.
        // 2026-07-28: two doors now, so the ladder has three honest states instead of one.
        // Never promise gifts at the shipping door again: that was the exact bug class the
        // 07-19 price-aware rewrite fixed, and splitting the doors re-opens it if we are lazy.
        // 2026-10-10: the staircase is the story. Under 6 she sees how close $20 a pack is.
        var toSix = 6 - eff;
        if (GIFT_OFF) {
          // US / Canada: no gifts, and their shipping door is not $90, so price only.
          msg = toSix > 0
            ? bag + toSix + ' more ' + packs(toSix) + ' → ' + formatMoney(state.unitCents - perPackOff(6), currencySymbol) + ' a pack'
            : bag + '✓ ' + formatMoney(state.unitCents - perPackOff(eff), currencySymbol) + ' a pack';
        } else if (gift2Now) {
          msg = bag + '✓ ' + formatMoney(state.unitCents - perPackOff(eff), currencySymbol) + ' a pack · free shipping + 2 gifts';
        } else if (toSix === 1) {
          // 5 packs at $25 = $125, 6 at $20 = $120: the sixth pack makes the bag cheaper.
          msg = bag + 'Add 1 more pack and pay less: 6 for ' + formatMoney(6 * (state.unitCents - perPackOff(6)), currencySymbol) + ' + a free gift';
        } else if (giftsNow) {
          msg = bag + '✓ ' + formatMoney(state.unitCents - perPackOff(eff), currencySymbol) + ' a pack · free shipping + 1 gift · ' + gift2In + ' more ' + packs(gift2In) + ' → 2 gifts';
        } else if (toSix > 0) {
          msg = bag + toSix + ' more ' + packs(toSix) + ' → ' + formatMoney(state.unitCents - perPackOff(6), currencySymbol) + ' a pack + a free gift' + (shipNow ? ' · ✓ free shipping' : '');
        } else if (shipNow) {
          msg = bag + '✓ Free shipping · ' + giftsIn + ' more ' + packs(giftsIn) + ' → a free gift';
        } else {
          msg = bag + shipIn + ' more ' + packs(shipIn) + ' → free shipping';
        }

        var unlocked = GIFT_OFF ? toSix <= 0 : (shipNow || giftsNow);
        bundleMsgEl.textContent = msg;
        bundleMsgEl.classList.toggle('qlv2-bundle-savings--unlocked', unlocked);
      }

      // Sticky shade name
      var stickyShadeEl = section.querySelector('[data-ql-sticky-shade]');
      if (stickyShadeEl && state.shadeName) stickyShadeEl.textContent = state.shadeName;
    }

    // ----- Qty stepper logic
    function changeQty(delta) {
      var newQty = state.qty + delta;
      if (newQty < 1) newQty = 1;
      if (newQty > 80) newQty = 80;
      state.qty = newQty;
      render();
    }

    if (minusBtn) minusBtn.addEventListener('click', function () { changeQty(-1); });
    if (plusBtn) plusBtn.addEventListener('click', function () { changeQty(1); });
    if (stickyMinusBtn) stickyMinusBtn.addEventListener('click', function () { changeQty(-1); });
    if (stickyPlusBtn) stickyPlusBtn.addEventListener('click', function () { changeQty(1); });

    function setQtyFromInput(inp) {
      var n = parseInt(inp.value, 10);
      if (isNaN(n) || n < 1) n = 1;
      if (n > 80) n = 80;
      state.qty = n;
      render();
    }
    if (qtyDisplay && qtyDisplay.tagName === 'INPUT') {
      qtyDisplay.addEventListener('change', function () { setQtyFromInput(qtyDisplay); });
      qtyDisplay.addEventListener('blur', function () { setQtyFromInput(qtyDisplay); });
      qtyDisplay.addEventListener('input', function () {
        qtyDisplay.value = qtyDisplay.value.replace(/[^0-9]/g, '');
      });
    }
    if (stickyQtyDisplay && stickyQtyDisplay.tagName === 'INPUT') {
      stickyQtyDisplay.addEventListener('change', function () { setQtyFromInput(stickyQtyDisplay); });
      stickyQtyDisplay.addEventListener('blur', function () { setQtyFromInput(stickyQtyDisplay); });
      stickyQtyDisplay.addEventListener('input', function () {
        stickyQtyDisplay.value = stickyQtyDisplay.value.replace(/[^0-9]/g, '');
      });
    }

    // ----- Mix & Save tiles → tap to set the bundle quantity (added 2026-05-30)
    // These tiles looked tappable but did nothing (Clarity dead-click hotspot). A tap
    // now sets qty to that pack count; render() highlights the matching tile; then we
    // bring the Add to Cart into view and pulse it so the next step is obvious.
    function pulseMainCta() {
      if (!mainCta) return;
      mainCta.classList.remove('qlv2-cta--pulse');
      void mainCta.offsetWidth; // restart the animation
      mainCta.classList.add('qlv2-cta--pulse');
      setTimeout(function () { mainCta.classList.remove('qlv2-cta--pulse'); }, 650);
    }
    function selectBundle(tile) {
      var n = parseInt(tile.getAttribute('data-ql-bundle-select'), 10);
      if (isNaN(n)) return;
      if (n < 1) n = 1;
      if (n > 80) n = 80;
      state.qty = n;
      render();
      if (mainCta && mainCta.scrollIntoView) {
        mainCta.scrollIntoView({ block: 'center', behavior: 'smooth' });
      }
      pulseMainCta();
    }
    bundleTiles.forEach(function (tile) {
      tile.addEventListener('click', function () { selectBundle(tile); });
      tile.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
          e.preventDefault();
          selectBundle(tile);
        }
      });
    });




    // ----- Show all shades expander
    var showAllBtn = section.querySelector('[data-qlv2-show-all]');
    var mainGrid = section.querySelector('[data-qlv2-main-grid]');
    if (showAllBtn && mainGrid) {
      showAllBtn.addEventListener('click', function () {
        mainGrid.classList.remove('qlv2-shade-grid--capped');
        mainGrid.classList.add('qlv2-shade-grid--expanded');
        showAllBtn.hidden = true;
      });
    }

    // ----- Shade picker
    var shadeRadios = section.querySelectorAll('[data-ql-shade]');
    var shadePreviewImg = section.querySelector('[data-qlv2-shade-preview-img]');

    // 2026-09-02: shade model slide. Tapping a swatch swaps the HERO (slide 1) to that shade's
    // pack shot and scrolls the rail back to slide 1, so a model slide left in its authored
    // position sits a dozen swipes away and is never found. Move it to sit directly after the
    // hero instead, so the pack stays first and the model is literally the next swipe.
    // Hidden unless its own shade is selected, so no shade ever shows another shade's model.
    // The editorial hero is a model shot on landing, so it carries the same tag. The moment a
    // swatch swaps that hero to a pack shot the tag has to go, or it describes the wrong picture.
    var heroTag = section.querySelector('[data-ql-hero-tag]');
    function syncHeroTag() {
      if (!heroTag || !heroImg) return;
      var f = heroTag.getAttribute('data-hero-file') || '';
      var src = heroImg.getAttribute('src') || '';
      heroTag.hidden = !(f && src.indexOf(f) !== -1);
    }

    // Label only the selected shade's hero photo, never the opening editorial image.
    var selectedHeroTag = null;
    var selectedHeroShade = null;
    var selectedHeroContext = null;
    function labelSelectedHero(name) {
      var slide = heroImg && heroImg.closest('.ql-gallery__slide');
      if (!slide) return;
      if (!selectedHeroTag) {
        selectedHeroTag = document.createElement('span');
        selectedHeroTag.className = 'ql-model-tag ql-model-caption';
        selectedHeroTag.setAttribute('data-ql-selected-hero-tag', '');
        selectedHeroShade = document.createElement('strong');
        selectedHeroShade.className = 'ql-model-caption__shade';
        selectedHeroContext = document.createElement('small');
        selectedHeroContext.className = 'ql-model-caption__context';
        selectedHeroTag.appendChild(selectedHeroShade);
        selectedHeroTag.appendChild(selectedHeroContext);
        slide.appendChild(selectedHeroTag);
      }
      // Match the quiet two-line caption on the 613 model photo.
      var parts = name.match(/^(.+?)\s+[\u2013\u2014]\s+(.+)$/) ||
        name.match(/^(.+?)\s+\[([^\]]+)\](.*)$/);
      selectedHeroShade.textContent = parts ? parts[1] : name;
      selectedHeroContext.textContent = parts ? parts[2] + (parts[3] || '') : '';
      selectedHeroContext.hidden = !selectedHeroContext.textContent;
      if (heroTag) heroTag.hidden = true;
    }

    function applyShadeModel(variantId) {
      var models = section.querySelectorAll('[data-shade-model]');
      if (!models.length) return;
      var heroSlide = heroImg ? heroImg.closest('.ql-gallery__slide') : null;
      var insertAfter = heroSlide;
      models.forEach(function (m) {
        if (String(m.getAttribute('data-shade-model')) !== String(variantId)) {
          m.hidden = true;
          return;
        }
        if (insertAfter && insertAfter.parentNode && m.previousElementSibling !== insertAfter) {
          insertAfter.parentNode.insertBefore(m, insertAfter.nextSibling);
        }
        m.hidden = false;
        insertAfter = m;
        var img = m.querySelector('img[data-ql-lazy-img]');
        if (img) {
          var ds = img.getAttribute('data-srcset');
          var d = img.getAttribute('data-src');
          if (ds) { img.setAttribute('srcset', ds); img.removeAttribute('data-srcset'); }
          if (d) { img.setAttribute('src', d); img.removeAttribute('data-src'); }
          img.removeAttribute('data-ql-lazy-img');
        }
      });
    }

    function applyShade(radio, skipImage) {
      if (!radio || !radio.checked) return;
      applyShadeModel(radio.value);
      syncHeroTag();

      // Auto-expand group
      expandGroupForRadio(radio);

      // Update name
      var name = radio.getAttribute('data-shade-name') || radio.value;
      state.shadeName = name;
      shadeNameEls.forEach(function (el) { el.textContent = name; });
      if (selectedNameEl) selectedNameEl.textContent = name;

      // Update variant ID in hidden input
      if (variantInput) variantInput.value = radio.value;

      // Update price
      var newPrice = parseInt(radio.getAttribute('data-price-cents') || '', 10);
      if (!isNaN(newPrice) && newPrice > 0) {
        state.unitCents = newPrice;
      }
      render();

      // Swap the top hero image, then (mobile) glide it into view — see the scroll block
      // at the end of this !skipImage branch. The old 46px inline preview thumb was removed
      // 2026-07-08, so the hero itself is now the shade feedback.
      if (!skipImage) {
        // A swatch tap sends mobile shoppers back above the normal sticky trigger.
        // Keep the selected shade and purchase action available after that interaction.
        stickyForcedByShade = true;
        var imgUrl = radio.getAttribute('data-shade-image');
        if (imgUrl) {
          var s600 = radio.getAttribute('data-shade-image-600');
          var s900 = radio.getAttribute('data-shade-image-900');
          // Inline preview at the swatches — the customer sees the shade without moving
          if (shadePreviewImg) {
            if (s600 && s900) shadePreviewImg.srcset = s600 + ' 360w, ' + s900 + ' 600w';
            shadePreviewImg.src = imgUrl;
          }
          // Top hero — updated silently for when they scroll up to the gallery
          if (heroImg) {
            // The editorial hero uses a lightweight mobile <source>. Remove it once a
            // shade is chosen so the selected pack image can take over the <img>.
            if (heroSource) heroSource.removeAttribute('srcset');
            if (s600 && s900) heroImg.srcset = s600 + ' 600w, ' + s900 + ' 900w';
            heroImg.src = s900 || imgUrl;
            heroImg.alt = name + ' braiding hair';
            syncHeroTag();
            labelSelectedHero(name);
          }
        }
        // Keep the gallery carousel aligned to the hero slide (horizontal only — never scrolls the page)
        var gallery = section.querySelector('.ql-gallery');
        if (gallery && heroImg) {
          var slide = heroImg.closest('.ql-gallery__slide');
          if (slide) {
            var slides = gallery.querySelectorAll('.ql-gallery__slide');
            var heroIndex = Array.prototype.indexOf.call(slides, slide);
            if (heroIndex >= 0) {
              gallery.scrollTo({ left: gallery.offsetWidth * heroIndex, behavior: 'smooth' });
              var pFill = section.querySelector('[data-ql-progress-fill]');
              if (pFill) pFill.style.transform = 'translateX(' + (heroIndex * 100) + '%)';
            }
          }
        }

        // Auto-scroll the FULL photo into view on tap (mobile) so the shade change happens
        // right in front of the shopper (founder 2026-07-09: "colours changing in front of
        // them"). Chosen over pinning/cropping the hero, which mangled the mix of model shots
        // and flat-hair shots. Only fires when the hero isn't already mostly in view, so a
        // candy-buyer sitting at the top isn't yanked (that was why the old always-scroll was
        // removed 2026-05-22). Desktop hero is sticky beside the picker, so skip it there.
        if (window.innerWidth <= 1023 && heroImg) {
          var mediaEl = heroImg.closest('.ql-buy__media') || heroImg;
          var mr = mediaEl.getBoundingClientRect();
          var visiblePx = Math.min(mr.bottom, window.innerHeight) - Math.max(mr.top, 0);
          if (mr.height > 0 && visiblePx / mr.height < 0.75) {
            window.scrollTo({ top: Math.max(mr.top + window.scrollY - 70, 0), behavior: 'smooth' });
          }
        }
        if (updateStickybar) updateStickybar();
      }

      // Update swatch visual state
      shadeRadios.forEach(function (r) {
        var label = r.closest('.ac-swatch');
        if (label) label.classList.toggle('is-selected', r.checked);
      });
    }

    shadeRadios.forEach(function (radio) {
      radio.addEventListener('change', function () { applyShade(radio); });
      // Clicking the already-selected default shade does not emit a change event.
      radio.addEventListener('click', function () {
        if (radio.checked && variantInput && variantInput.value === radio.value) {
          applyShade(radio);
        }
      });
    });

    // ----- Swatch group collapse/expand
    var groupToggles = section.querySelectorAll('[data-ac-group-toggle]');
    groupToggles.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var group = btn.closest('.ac-swatch-group');
        if (!group) return;
        var expanded = group.classList.toggle('ac-swatch-group--expanded');
        btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        var more = btn.querySelector('[data-ac-group-toggle-more]');
        var less = btn.querySelector('[data-ac-group-toggle-less]');
        if (more) more.hidden = expanded;
        if (less) less.hidden = !expanded;
      });
    });

    function expandGroupForRadio(radio) {
      var group = radio.closest('.ac-swatch-group');
      if (!group || group.classList.contains('ac-swatch-group--expanded')) return;
      group.classList.add('ac-swatch-group--expanded');
      var btn = group.querySelector('[data-ac-group-toggle]');
      if (btn) {
        btn.setAttribute('aria-expanded', 'true');
        var more = btn.querySelector('[data-ac-group-toggle-more]');
        var less = btn.querySelector('[data-ac-group-toggle-less]');
        if (more) more.hidden = true;
        if (less) less.hidden = false;
      }
    }

    // ----- Initial state
    var initialChecked = section.querySelector('[data-ql-shade]:checked');
    if (initialChecked) {
      state.shadeName = initialChecked.getAttribute('data-shade-name') || '';
      if (variantInput) variantInput.value = initialChecked.value;
      var initPrice = parseInt(initialChecked.getAttribute('data-price-cents') || '', 10);
      if (!isNaN(initPrice) && initPrice > 0) state.unitCents = initPrice;

      // 2026-06-27: when a shade is deep-linked via ?variant= (e.g. the "Get the look" install
      // links from the braider showcase), swap the hero image to that shade on load so the picture
      // matches the colour the customer came to see. Without this, the buy box says "Lavender" but
      // the hero still shows the default 1B model. Default landings (no ?variant=) keep the curated
      // lifestyle hero untouched — only explicit deep-links swap it.
      var urlVariant = new URLSearchParams(window.location.search).get('variant');
      if (urlVariant && urlVariant === initialChecked.value) {
        applyShade(initialChecked);
      }
    }
    syncHeroTag();
    render();

    // ----- Bundle progress bar
    var ELIGIBLE_HANDLES = [
      '26-inch-pre-stretched-braiding-hair',
      '22-inch-pre-stretched-braiding-hair',
      '16-inch-pre-stretched-braiding-hair'
    ];
    var progressFill = section.querySelector('[data-qlv2-fill]');
    var progressMsg = section.querySelector('[data-qlv2-msg]');
    var progressMarkers = section.querySelectorAll('[data-qlv2-marker]');
    var prevTier = 0;

    var KIT_THRESHOLD = 7;
    var unitCentsForThreshold = state.unitCents || 1000;

    function updateProgressBar(count, animate) {
      if (!progressFill || !progressMsg) return;
      var pct = Math.min((count / KIT_THRESHOLD) * 100, 100);
      progressFill.style.width = pct + '%';

      // Update markers
      progressMarkers.forEach(function (m) {
        var val = parseInt(m.getAttribute('data-qlv2-marker'), 10);
        var hit = count >= val;
        m.classList.toggle('qlv2-progress__marker--hit', hit);
        if (animate && hit && !m.classList.contains('qlv2-progress__marker--pulsed')) {
          m.classList.add('qlv2-progress__marker--pulse');
          m.classList.add('qlv2-progress__marker--pulsed');
          setTimeout(function () { m.classList.remove('qlv2-progress__marker--pulse'); }, 700);
        }
      });

      var msg = '';
      var celebrate = false;
      var remaining = KIT_THRESHOLD - count;

      // Install Kit promo retired. Progress bar HTML removed from PDP, so
      // this function early-returns above. Strings cleared to avoid stale
      // install-kit copy if a future template re-adds the data attributes.
      msg = '';

      progressMsg.textContent = msg;
      progressMsg.classList.toggle('qlv2-progress__msg--celebrate', celebrate);
      if (celebrate) {
        setTimeout(function () {
          progressMsg.classList.remove('qlv2-progress__msg--celebrate');
        }, 2500);
      }

      prevTier = count;
    }

    function fetchCartAndUpdate(animate) {
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var count = 0;
          cart.items.forEach(function (item) {
            if (ELIGIBLE_HANDLES.indexOf(item.handle) !== -1) {
              count += item.quantity;
            }
          });
          updateProgressBar(count, animate);
        })
        .catch(function () {});
    }

    // Initial load
    fetchCartAndUpdate(false);

    // ----- Dynamic dispatch message — honest about weekends + after-cutoff
    // Order before 1pm AEST weekday → ships today
    // After 1pm weekday → ships tomorrow (or Monday if Fri)
    // Saturday/Sunday → ships Monday
    (function updateDispatchMessage() {
      var el = section.querySelector('[data-qlv2-dispatch]');
      if (!el) return;
      try {
        // Get current time in Australia/Sydney (AEST/AEDT — handles DST)
        var fmt = new Intl.DateTimeFormat('en-AU', {
          timeZone: 'Australia/Sydney',
          weekday: 'long', hour: 'numeric', hour12: false
        });
        var parts = fmt.formatToParts(new Date());
        var weekday = parts.find(function (p) { return p.type === 'weekday'; }).value; // "Monday" ... "Sunday"
        var hour = parseInt(parts.find(function (p) { return p.type === 'hour'; }).value, 10);
        var beforeCutoff = hour < 13; // before 1pm
        var msg;
        var weekdays = { Monday: 1, Tuesday: 2, Wednesday: 3, Thursday: 4, Friday: 5, Saturday: 6, Sunday: 0 };
        var d = weekdays[weekday];
        if (d >= 1 && d <= 5 && beforeCutoff) {
          msg = 'Order before <strong>1pm AEST</strong> → ships today';
        } else if (d === 5 && !beforeCutoff) {
          msg = 'Order now → ships <strong>Monday</strong>';
        } else if (d >= 1 && d <= 4 && !beforeCutoff) {
          msg = 'Order now → ships <strong>tomorrow</strong>';
        } else if (d === 6) {
          msg = 'Order now → ships <strong>Monday</strong>';
        } else if (d === 0) {
          msg = 'Order now → ships <strong>Monday</strong>';
        }
        if (msg) el.innerHTML = msg;
      } catch (e) {
        // Fallback to the default text already in HTML
      }
    })();

    // Swipe cue on ALL FOUR colour rails — answers "how does anyone know these slide?".
    // 2026-07-09 (was: only the first/vibrants rail). Every horizontal rail — Naturals & Ombré
    // (.ac-swatch-group__grid) AND Vibrants & Blends (.qlv2-shade-grid--rail) — gets the treatment.
    // For each rail that actually overflows and isn't scrolled to the end we (a) show its "Swipe →"
    // hint (the label's [data-ql-blends-hint]) and (b) add .qlv2-has-more for the right-edge fade.
    // Both turn OFF at the end (and never show on lengths whose rows don't overflow) so the cue is
    // never misleading.
    (function railSwipeCues() {
      var rails = section.querySelectorAll('.ac-swatch-group__grid, .qlv2-shade-grid--rail');
      if (!rails.length) return;
      function updateRail(rail) {
        // hint lives in the label immediately before the rail
        var label = rail.previousElementSibling;
        var hint = label ? label.querySelector('[data-ql-blends-hint]') : null;
        var overflow = rail.scrollWidth - rail.clientWidth > 8;
        var atEnd = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 8;
        var showCue = overflow && !atEnd;
        if (hint) hint.classList.toggle('is-on', showCue);
        rail.classList.toggle('qlv2-has-more', showCue);
      }
      rails.forEach(function (rail) {
        updateRail(rail);
        rail.addEventListener('scroll', function () { updateRail(rail); }, { passive: true });
      });
      function updateAll() { rails.forEach(updateRail); }
      window.addEventListener('resize', updateAll);
      window.addEventListener('load', updateAll); // chip images can change scrollWidth after load
    })();

    // ----- Hoisted-review photo lightbox (tap face → see full install)
    section.querySelectorAll('[data-qlv2-review-photo]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var img = btn.querySelector('img');
        if (!img) return;
        var fullSrc = btn.getAttribute('data-full-src') || img.src;
        var alt = img.alt || 'Customer photo';
        var overlay = document.createElement('div');
        overlay.className = 'qlv2-photo-overlay';
        overlay.setAttribute('role', 'dialog');
        overlay.setAttribute('aria-modal', 'true');
        overlay.innerHTML =
          '<button type="button" class="qlv2-photo-overlay__close" aria-label="Close">×</button>' +
          '<img src="' + fullSrc + '" alt="' + alt.replace(/"/g, '&quot;') + '" class="qlv2-photo-overlay__img">';
        function close() {
          if (overlay.parentNode) overlay.parentNode.removeChild(overlay);
          document.body.style.overflow = '';
          document.removeEventListener('keydown', onKey);
        }
        function onKey(ev) { if (ev.key === 'Escape') close(); }
        overlay.addEventListener('click', function (ev) {
          if (ev.target === overlay || ev.target.classList.contains('qlv2-photo-overlay__close')) close();
        });
        document.addEventListener('keydown', onKey);
        document.body.appendChild(overlay);
        document.body.style.overflow = 'hidden';
      });
    });

    // ----- Colour chart popup — open the chart OVER the PDP so the shopper never leaves
    //       the buy flow mid-decision (every step off the page is a leak). Progressive
    //       enhancement: the trigger keeps its /pages/colour-chart href; JS intercepts the
    //       click ONLY when <dialog>.showModal is supported, otherwise the link navigates.
    //       Native <dialog> gives backdrop, Esc-to-close and focus-trap for free.
    (function chartDialog() {
      var trigger = section.querySelector('[data-ql-chart-open]');
      var dialog = section.querySelector('[data-ql-chart-dialog]');
      if (!trigger || !dialog || typeof dialog.showModal !== 'function') return;
      var closeBtn = dialog.querySelector('[data-ql-chart-close]');
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        dialog.showModal();
        document.body.style.overflow = 'hidden';
      });
      function close() { if (dialog.open) dialog.close(); }
      if (closeBtn) closeBtn.addEventListener('click', close);
      // click on the backdrop (target is the dialog itself) closes it
      dialog.addEventListener('click', function (e) { if (e.target === dialog) close(); });
      // fires on Esc too — restore page scroll whenever it closes
      dialog.addEventListener('close', function () { document.body.style.overflow = ''; });
    })();

    // ----- Length switcher — 16"/22"/26" are SEPARATE products; swap length IN PLACE
    //       (no reload) so price + colours change in front of the shopper (founder
    //       2026-07-09, prototyped as an artifact he approved). All three lengths render
    //       the SAME section type, so we can fetch a sibling page, replace THIS whole
    //       section with its buy zone, and re-init the same JS on it. Progressive
    //       enhancement: the pills are real <a href> links — no JS / unsupported browser /
    //       any fetch failure just navigates normally. Sibling pages are prefetched on idle
    //       (and on hover/touch) so the swap is instant.
    (function lengthSwitcher() {
      var wrap = section.querySelector('[data-ql-lengths]');
      if (!wrap) return;
      var pills = wrap.querySelectorAll('.qlv2-length-pill');
      if (!pills.length) return;
      if (!window.fetch || !window.DOMParser || !window.history || !history.pushState) return;

      var cache = {};
      function prefetch(url) {
        if (!url) return null;
        if (cache[url] !== undefined) return cache[url];
        cache[url] = fetch(url, { credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.text() : Promise.reject(new Error('bad status')); })
          .catch(function () { cache[url] = undefined; return null; });
        return cache[url];
      }

      // Warm the cache for the other lengths once the page is idle
      function warm() {
        pills.forEach(function (p) {
          if (!p.classList.contains('is-on')) prefetch(p.getAttribute('href'));
        });
      }
      if ('requestIdleCallback' in window) requestIdleCallback(warm); else setTimeout(warm, 1200);

      // Back/forward: re-render the correct length by reloading that URL (once, global guard)
      if (!window.__qlLenPop) {
        window.__qlLenPop = true;
        window.addEventListener('popstate', function (e) {
          if (e.state && e.state.qlLen) window.location.reload();
        });
      }

      function swap(url, pill) {
        pills.forEach(function (p) { p.classList.toggle('is-loading', p === pill); });
        Promise.resolve(prefetch(url)).then(function (html) {
          if (!html) { window.location.href = url; return; } // safe fallback: real nav
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-ql-section]');
          if (!fresh) { window.location.href = url; return; }
          var newTitle = doc.querySelector('title');

          // Keep the pill row visually anchored across the swap (heights differ per length)
          var oldTop = wrap.getBoundingClientRect().top;

          // Drop any sticky bar this section previously re-parented onto <body>
          var bodySticky = document.querySelectorAll('body > [data-ql-stickybar]');
          for (var i = 0; i < bodySticky.length; i++) bodySticky[i].remove();

          var imported = document.importNode(fresh, true);
          section.parentNode.replaceChild(imported, section);

          // Re-run the theme JS on the new section (idempotent; guarded by data-ql-init)
          initSection(imported);

          // Re-scan the Loox star widget if present (cosmetic — never blocks the swap)
          try {
            if (window.loox && typeof window.loox.reload === 'function') window.loox.reload();
            else if (window.Loox && typeof window.Loox.init === 'function') window.Loox.init();
          } catch (e) {}

          // Update the address + tab title without reloading
          try {
            history.pushState({ qlLen: true }, '', url);
            if (newTitle) document.title = newTitle.textContent;
          } catch (e) {}

          // Restore scroll so the new pill row sits where the old one was
          var newWrap = imported.querySelector('[data-ql-lengths]');
          if (newWrap) window.scrollBy(0, newWrap.getBoundingClientRect().top - oldTop);
        });
      }

      pills.forEach(function (pill) {
        if (pill.classList.contains('is-on')) return;
        var url = pill.getAttribute('href');
        pill.addEventListener('mouseenter', function () { prefetch(url); });
        pill.addEventListener('touchstart', function () { prefetch(url); }, { passive: true });
        pill.addEventListener('click', function (e) {
          // let ctrl/cmd/shift/middle-click open a new tab normally
          if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
          e.preventDefault();
          swap(url, pill);
        });
      });
    })();

    // ----- Sticky bar visibility
    // Keep the selected shade, quantity, and live total available from the moment a shopper
    // reaches colours, rather than making them scroll back down to the main buy row.
    // CSS hides .qlv2-stickybar at >=1024px for desktop.
    if (stickybar) {
      // 2026-06-27 (Safari fix): re-parent the sticky bar to <body> so its position:fixed anchors
      // to the VIEWPORT, not the product section. The Combine theme applies a transient transform
      // to sections during scroll-reveal; on Safari a transformed ancestor re-anchors a fixed
      // descendant, making the bar scroll away / disappear heading down (invisible to desktop
      // testing). As a direct body child no ancestor transform can affect it. All sticky element
      // references + click handlers were captured above, so they keep working after the move.
      if (stickybar.parentElement !== document.body) {
        document.body.appendChild(stickybar);
      }

      var ctaWrap = section.querySelector('[data-ql-cta-wrap]');
      var shadePicker = section.querySelector('[data-ql-shade-picker]');
      var stickyTrigger = shadePicker || ctaWrap || mainCta;
      updateStickybar = function () {
        if (!stickyTrigger) return;
        var rect = stickyTrigger.getBoundingClientRect();
        var mainRect = mainCta ? mainCta.getBoundingClientRect() : null;
        var mainCtaVisible = mainRect && mainRect.top < window.innerHeight && mainRect.bottom > 0;
        var reachedPurchaseArea = rect.top < window.innerHeight * 0.7;
        var shouldShow = !mainCtaVisible && (reachedPurchaseArea || stickyForcedByShade);
        stickybar.classList.toggle('ql-stickybar--visible', shouldShow);
        stickybar.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
      };
      updateStickybar();
      window.addEventListener('scroll', updateStickybar, { passive: true });
      window.addEventListener('resize', updateStickybar);
    }

    // ----- Sticky CTA → real form submit
    if (stickyCta && mainCta) {
      stickyCta.addEventListener('click', function (e) {
        e.preventDefault();
        if (mainCta.disabled) return;
        mainCta.click();
      });
    }

    // ----- Cart-aware braid count (candy buyer support) — 2026-06-06 PM
    // Reads /cart.js to find how many AC braiding packs are ALREADY in the bag.
    // Powers the cart-aware nudge: a candy buyer with 3 packs of Pankina in bag
    // sees "3 in your bag · 1 more for 12% off" when opening Chokoreti at qty 1,
    // instead of the wrong-by-self "Add 3 more". Excludes the $0 Install Kit gift
    // SKUs (they carry the _install_kit_gift line property).
    var BRAID_HANDLES = [
      '26-inch-pre-stretched-braiding-hair',
      '22-inch-pre-stretched-braiding-hair',
      '16-inch-pre-stretched-braiding-hair'
    ];
    function refreshCartBraidCount() {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var n = 0;
          for (var i = 0; i < cart.items.length; i++) {
            var it = cart.items[i];
            var isGift = it.properties && (it.properties._install_kit_gift === 'true' || it.properties._install_kit_gift === true);
            if (!isGift && BRAID_HANDLES.indexOf(it.handle) !== -1) {
              n += it.quantity;
            }
          }
          window.QLV2_CART_BRAIDS = n;
          render();
        })
        .catch(function () {});
    }
    document.addEventListener('cart-updated', refreshCartBraidCount, true);
    document.addEventListener('add-to-cart', refreshCartBraidCount, true);
    refreshCartBraidCount();

    // ----- Inline "added" toast — FALLBACK ONLY since T1.1 (2026-05-31): the
    // cart drawer now opens on add; this fires only if the drawer can't open.
    var productFormEl = section.querySelector('[data-js-product-form]');
    var addedEl = section.querySelector('[data-qlv2-added]');
    var addedTextEl = section.querySelector('[data-qlv2-added-text]');
    var addedTimeout = null;

    function getNudgeText(count) {
      // Install Kit promo retired — bundle tier savings handled by the
      // bundle-tier-deal section + Shopify automatic discount.
      return '';
    }

    function showAddedConfirmation(shadeName, qty, cartCount) {
      if (!addedEl || !addedTextEl) return;
      var label = shadeName + (qty > 1 ? ' × ' + qty : '') + ' added!';
      var nudge = getNudgeText(cartCount);
      addedTextEl.textContent = nudge ? label + ' · ' + nudge : label;
      addedEl.hidden = false;
      addedEl.classList.remove('qlv2-added--fade');
      if (addedTimeout) clearTimeout(addedTimeout);
      addedTimeout = setTimeout(function () {
        addedEl.classList.add('qlv2-added--fade');
        setTimeout(function () { addedEl.hidden = true; }, 300);
      }, 3000);
    }

    if (productFormEl) {
      productFormEl.addEventListener('add-to-cart', function () {
        var addedShade = state.shadeName || 'Item';
        var addedQty = state.qty;

        // Reset qty to 1 for next shade
        state.qty = 1;
        render();

        // T1.1 (2026-05-31): open the branded cart drawer on add. Matches
        // Combine's overlay default + the native main-product section. The
        // shared <product-form> re-renders the drawer contents BEFORE this
        // event fires, so the drawer shows the just-added item. This replaces
        // the old "no drawer interruption" inline toast, which now only fires
        // as a fallback if the drawer can't open.
        var drawerOpened = false;
        if (!document.body.classList.contains('template-cart') &&
            window.KROWN && KROWN.settings && KROWN.settings.cart_action === 'overlay') {
          var cartDrawer = document.getElementById('site-cart-sidebar');
          if (cartDrawer && typeof cartDrawer.show === 'function') {
            cartDrawer.show();
            drawerOpened = true;
          }
          var recDrawer = document.getElementById('cart-recommendations-sidebar');
          if (recDrawer && typeof recDrawer.generateRecommendations === 'function') {
            recDrawer.generateRecommendations();
          }
        }

        // Keep the on-PDP progress bar in sync (seen when the drawer is closed).
        // Show the inline toast only as a fallback when the drawer didn't open.
        fetch('/cart.js', { credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var count = 0;
            cart.items.forEach(function (item) {
              if (ELIGIBLE_HANDLES.indexOf(item.handle) !== -1) {
                count += item.quantity;
              }
            });
            updateProgressBar(count, true);
            if (!drawerOpened) showAddedConfirmation(addedShade, addedQty, count);
          })
          .catch(function () {
            if (!drawerOpened) showAddedConfirmation(addedShade, addedQty, 0);
          });
      });
    }

    // ----- Install Kit gift tiles -> nudge to the $90 unlock (2026-06-13)
    // Clarity dead-tap heatmap: the free-gift tiles were a top dead-click target (~15%) — people
    // tap to "pick" a gift and nothing happens. Tap anywhere on the kit block -> scroll the
    // unlock tile into view + pulse it, so "I want that gift" connects to "reach $90".
    // 2026-07-27: the 12-pack tile no longer exists, so the fallback points at the 6-pack
    // rung, which is the one that actually lands on $90.
    var kitBlock = section.querySelector('.qlv2-installkit');
    if (kitBlock) {
      var unlockTile = section.querySelector('.qlv2-mixsave__col--best[data-ql-bundle-select]')
        || section.querySelector('[data-ql-bundle-select="6"]')
        || section.querySelector('.qlv2-mixsave__col--best');
      if (unlockTile) {
        var nudgeToUnlock = function () {
          unlockTile.scrollIntoView({ behavior: 'smooth', block: 'center' });
          unlockTile.classList.add('qlv2-pulse');
          setTimeout(function () { unlockTile.classList.remove('qlv2-pulse'); }, 1500);
        };
        kitBlock.style.cursor = 'pointer';
        kitBlock.setAttribute('role', 'button');
        kitBlock.setAttribute('tabindex', '0');
        kitBlock.setAttribute('aria-label', 'See how to unlock your free Install Kit');
        kitBlock.addEventListener('click', nudgeToUnlock);
        kitBlock.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); nudgeToUnlock(); }
        });
      }
    }

    // ----- The three questions: tabs, sliding indicator, counted numbers (2026-07-27)
    //
    // Panels are only ever shown or hidden, never created or destroyed, so all three
    // answers stay in the HTML source for crawlers and language models regardless of
    // which one a human can see. Arrow keys move between tabs per the ARIA tabs pattern.
    //
    // Three pieces of motion, each with a job:
    //   the sliding indicator  -> spatial: shows WHERE she moved, not just that she did
    //   the panel rise + blur  -> state:   the content changed, and it is one thing
    //                                      resolving rather than two objects swapping
    //   the counting number    -> hierarchy: pulls the eye to the evidence, once
    // Nothing here loops, and nothing animates on a repeated keyboard action.
    (function () {
      var qtabRoot = section.querySelector('[data-qlv2-qtabs]');
      if (!qtabRoot) return;
      var qtabs = Array.prototype.slice.call(qtabRoot.querySelectorAll('[role="tab"]'));
      if (!qtabs.length) return;

      var ink = qtabRoot.querySelector('[data-qlv2-qink]');
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      // ---- counted numbers -------------------------------------------------
      // Each number is written into the HTML at its final value, so with no JS, with JS
      // that fails, or under reduced motion, the correct figure is already on screen.
      // The animation only ever replaces a correct value with the same correct value.
      function countUp(el) {
        if (el.getAttribute('data-counted') === '1') return;
        el.setAttribute('data-counted', '1');

        var target = parseFloat(el.getAttribute('data-ql-count'));
        if (isNaN(target)) return;
        var isMoney = el.hasAttribute('data-ql-count-money');
        if (isMoney) target = target / 100;

        var format = function (v) {
          return isMoney ? '$' + v.toFixed(2) : String(Math.round(v));
        };
        if (reduce) { el.textContent = format(target); return; }

        var DURATION = 700;
        var startedAt = null;
        var step = function (now) {
          if (startedAt === null) startedAt = now;
          var t = Math.min((now - startedAt) / DURATION, 1);
          // easeOutCubic. Fast first, settling at the end, same character as the
          // ease-out curve the CSS uses, so the number and the panel feel related.
          var eased = 1 - Math.pow(1 - t, 3);
          el.textContent = format(target * eased);
          if (t < 1) requestAnimationFrame(step);
          else el.textContent = format(target);
        };
        requestAnimationFrame(step);
      }

      function countInside(panel) {
        if (!panel) return;
        Array.prototype.forEach.call(panel.querySelectorAll('[data-ql-count]'), countUp);
      }

      // ---- sliding indicator ----------------------------------------------
      // Width 1px in CSS, so scaleX() is the tab's width in pixels. Transform only, which
      // keeps this off the layout and paint path entirely.
      function moveInk(tab, animate) {
        if (!ink || !tab) return;
        var left = tab.offsetLeft - qtabRoot.querySelector('.qlv2-qtabs__bar').scrollLeft;
        var w = tab.offsetWidth;
        if (!animate) {
          var prev = ink.style.transition;
          ink.style.transition = 'none';
          ink.style.transform = 'translateX(' + left + 'px) scaleX(' + w + ')';
          // Force the browser to apply the untransitioned position before restoring the
          // transition, otherwise the first real move animates from 0 and sweeps.
          void ink.offsetWidth;
          ink.style.transition = prev;
          return;
        }
        ink.style.transform = 'translateX(' + left + 'px) scaleX(' + w + ')';
      }

      // ---- tab switching ---------------------------------------------------
      function selectTab(tab, animate) {
        qtabs.forEach(function (t) {
          var on = t === tab;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          var panel = document.getElementById(t.getAttribute('aria-controls'));
          if (!panel) return;
          if (on) {
            panel.hidden = false;
            if (animate && !reduce) {
              panel.classList.add('qlv2-qpanel__in');
              // Two frames: one for the browser to lay the panel out with the start
              // state applied, one to flip to the end state so the transition runs.
              requestAnimationFrame(function () {
                requestAnimationFrame(function () {
                  panel.classList.remove('qlv2-qpanel__in');
                });
              });
            }
            countInside(panel);
          } else {
            // Exit is instant. Faster out than in, and there is no spatial continuity
            // between two different answers worth preserving.
            panel.hidden = true;
            panel.classList.remove('qlv2-qpanel__in');
          }
        });
        moveInk(tab, animate);
      }

      qtabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () { selectTab(tab, true); });
        tab.addEventListener('keydown', function (e) {
          var next = null;
          if (e.key === 'ArrowRight') next = qtabs[(i + 1) % qtabs.length];
          else if (e.key === 'ArrowLeft') next = qtabs[(i - 1 + qtabs.length) % qtabs.length];
          else if (e.key === 'Home') next = qtabs[0];
          else if (e.key === 'End') next = qtabs[qtabs.length - 1];
          if (next) { e.preventDefault(); next.focus(); selectTab(next, true); }
        });
      });

      var initial = qtabs.filter(function (t) { return t.getAttribute('aria-selected') === 'true'; })[0] || qtabs[0];

      // Place the indicator without animation on load, so it does not sweep in from the
      // left edge on first paint. Fonts can land after this runs and change tab widths,
      // so re-measure once the font is ready and on resize.
      var placeInk = function () { moveInk(
        qtabs.filter(function (t) { return t.getAttribute('aria-selected') === 'true'; })[0] || qtabs[0],
        false
      ); };
      placeInk();
      if (document.fonts && document.fonts.ready && document.fonts.ready.then) {
        document.fonts.ready.then(placeInk);
      }
      var resizeTimer;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(placeInk, 120);
      });

      // Count the open panel when the block first reaches the viewport, not on page load.
      // A number that finished counting three screens above her did nothing.
      var openPanel = document.getElementById(initial.getAttribute('aria-controls'));
      if (!('IntersectionObserver' in window)) {
        countInside(openPanel);
      } else {
        var obs = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            countInside(openPanel);
            obs.disconnect();
          });
        }, { threshold: 0.4 });
        obs.observe(qtabRoot);
      }
    })();

    // ----- Gallery progress bar (SKIMS-style, replaced dots 2026-07-21) + lazy video source swap on active slide
    var gallery = section.querySelector('.ql-gallery');
    var progressFill = section.querySelector('[data-ql-progress-fill]');
    if (gallery) {
      var slides = gallery.querySelectorAll('.ql-gallery__slide');
      // Set fill width to one slide's share; it then slides by whole steps on scroll.
      var slideCount = slides.length || 1;
      if (progressFill) progressFill.style.width = (100 / slideCount) + '%';
      var setProgress = function (index) {
        if (progressFill) progressFill.style.transform = 'translateX(' + (index * 100) + '%)';
      };
      var hydrateImage = function (slide) {
        if (!slide) return;
        var lazyImg = slide.querySelector('img[data-ql-lazy-img]');
        if (!lazyImg) return;
        var srcset = lazyImg.getAttribute('data-srcset');
        var src = lazyImg.getAttribute('data-src');
        if (srcset) {
          lazyImg.setAttribute('srcset', srcset);
          lazyImg.removeAttribute('data-srcset');
        }
        if (src) {
          lazyImg.setAttribute('src', src);
          lazyImg.removeAttribute('data-src');
        }
        lazyImg.removeAttribute('data-ql-lazy-img');
      };
      var hydrateSlide = function (idx) {
        var slide = slides[idx];
        if (!slide) return;
        hydrateImage(slide);
        var lazyVid = slide.querySelector('video[data-ql-lazy-source]');
        if (!lazyVid) return;
        var src = lazyVid.querySelector('source[data-src]');
        if (src) {
          src.setAttribute('src', src.getAttribute('data-src'));
          src.removeAttribute('data-src');
        }
        lazyVid.removeAttribute('data-ql-lazy-source');
        // 2026-06-13: once the video is live, expose native controls (pause / unmute / scrub).
        // Clarity dead-tap heatmap (mobile) showed the video as the #1 dead-click target — people
        // tapping the PLAYING muted-loop video to pause/unmute and getting nothing. Controls only
        // appear after this hydrate (on tap or scroll-into-view), so the lazy-load speed win stays.
        lazyVid.setAttribute('controls', '');
        lazyVid.setAttribute('controlsList', 'nodownload');
        // Hide the play overlay on BOTH paths (tap + scroll-into-view), not just tap.
        var hydratePlayBtn = slide.querySelector('[data-ql-play]');
        if (hydratePlayBtn) hydratePlayBtn.style.display = 'none';
        try { lazyVid.load(); lazyVid.play().catch(function () {}); } catch (e) {}
      };
      gallery.addEventListener('scroll', function () {
        var index = Math.round(gallery.scrollLeft / gallery.offsetWidth);
        setProgress(index);
        hydrateSlide(index);
        hydrateSlide(index + 1);
      }, { passive: true });
      hydrateSlide(0);

      // Click-to-play (locked 2026-06-08): videos moved from autoplay to click-to-play to drop 2.27MB from initial page weight. Tap the slide (or the play button overlay) → hydrate the source + play + hide the overlay.
      gallery.addEventListener('click', function (e) {
        var slide = e.target.closest('.ql-gallery__slide');
        if (!slide) return;
        var lazyVid = slide.querySelector('video[data-ql-lazy-source]');
        if (!lazyVid) return;
        var slideIdx = Array.prototype.indexOf.call(slides, slide);
        if (slideIdx < 0) return;
        hydrateSlide(slideIdx);
        var playBtn = slide.querySelector('[data-ql-play]');
        if (playBtn) playBtn.style.display = 'none';
      });

      // ----- Image tap-to-zoom lightbox (2026-06-13)
      // Clarity dead-tap heatmap: the hero IMAGE was a top dead-click target — people tap it
      // expecting a zoom to inspect the exact shade/texture (the #1 purchase + return concern),
      // and nothing happened. Opens a full-screen view of the CURRENTLY shown shade with native
      // pinch-zoom. Singleton, lazy-created on first open, appended to <body>. Images only —
      // the video slide has no <img>, so this never fires on the video.
      var qlLightbox, qlLightboxImg;
      function qlCloseLightbox() {
        if (!qlLightbox) return;
        qlLightbox.classList.remove('is-open');
        document.body.classList.remove('ql-lightbox-open');
        qlLightboxImg.removeAttribute('src');
      }
      function qlEnsureLightbox() {
        if (qlLightbox) return;
        qlLightbox = document.createElement('div');
        qlLightbox.className = 'ql-lightbox';
        qlLightbox.setAttribute('role', 'dialog');
        qlLightbox.setAttribute('aria-modal', 'true');
        qlLightbox.setAttribute('aria-label', 'Zoomed product image');
        qlLightbox.innerHTML =
          '<button type="button" class="ql-lightbox__close" aria-label="Close zoom">×</button>' +
          '<img class="ql-lightbox__img" alt="">';
        document.body.appendChild(qlLightbox);
        qlLightboxImg = qlLightbox.querySelector('.ql-lightbox__img');
        qlLightbox.querySelector('.ql-lightbox__close').addEventListener('click', qlCloseLightbox);
        qlLightbox.addEventListener('click', function (e) { if (e.target === qlLightbox) qlCloseLightbox(); });
        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape' && qlLightbox.classList.contains('is-open')) qlCloseLightbox();
        });
      }
      gallery.addEventListener('click', function (e) {
        var img = e.target.closest('.ql-gallery__slide img');
        if (!img) return;
        var src = img.currentSrc || img.src;
        if (!src) return;
        // Request a sharper copy for zoom (Shopify never upscales past the source, so this is safe)
        if (/\/cdn\/shop\//.test(src)) src = src.replace(/([?&])width=\d+/, '$1width=1600');
        qlEnsureLightbox();
        qlLightboxImg.setAttribute('src', src);
        qlLightboxImg.setAttribute('alt', img.getAttribute('alt') || '');
        qlLightbox.classList.add('is-open');
        document.body.classList.add('ql-lightbox-open');
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
